import React, { Fragment, useEffect, useMemo, useRef } from 'react';

import { Dialog, Transition } from '@headlessui/react';

import { Logo, LogoRGOL, LogoRGOLSmall } from '../../assets';

export default function NavigationDrawer({
  children = null,
  menuRoute,
  menuNavigation = null,
  isOpen,
  onClose,
  afterLeave = () => {}
}) {
  const menuRef = useRef(null);

  const locale = useMemo(() => window?.config?.iso_language_code, []);

  useEffect(() => {
    if (menuRef.current) {
      menuRef.current.scrollTo({
        top: 0
      });
    }
  }, [menuRoute, menuRef]);

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog
        className="relative z-[6000]" // Because of Kindly.
        onClose={() => onClose()}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" />
        </Transition.Child>
        <Dialog.Panel className="fixed inset-0 max-h-screen lg:inset-auto lg:inset-y-0 lg:flex lg:flex-col">
          <div className="hidden h-16 bg-white px-6 lg:flex lg:shrink-0 lg:items-center">
            <a
              href="/"
              aria-label="Home"
              className="flex flex-none items-center focus:outline-none"
            >
              {['el-GR'].includes(locale) ? (
                <>
                  <LogoRGOL className="hidden h-[24px] shrink-0 lg:block" />
                  <LogoRGOLSmall className="block h-[24px] shrink-0 lg:hidden" />
                </>
              ) : (
                <Logo className="h-[24px] w-[118px] shrink-0" />
              )}
            </a>
          </div>
          {menuNavigation}
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-200"
            enterFrom="transform-gpu translate-x-8 lg:-translate-x-8 opacity-0"
            enterTo="transform-gpu translate-x-0 opacity-100"
            leave="ease-in-out duration-200"
            leaveFrom="transform-gpu translate-x-0 opacity-100"
            leaveTo="transform-gpu translate-x-8 lg:-translate-x-8 opacity-0"
            afterLeave={() => afterLeave()}
          >
            <div
              ref={menuRef}
              className="relative h-full grow overflow-x-hidden overflow-y-scroll bg-white/90 backdrop-blur-sm lg:h-auto"
            >
              {children}
            </div>
          </Transition.Child>
        </Dialog.Panel>
      </Dialog>
    </Transition>
  );
}
